module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavyrain@2-c307854b23f15e14b0b5b02c833c5b42.png";